(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. Hero text entrance
     Adds .hwc-hero-ready to body, triggering CSS transitions
     ---------------------------------------------------------- */
  function initHeroEntrance() {
    var hero = document.querySelector('.hwc-landing-hero');
    if (!hero) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.classList.add('hwc-entrance-ready');
      });
    });
  }

  /* ----------------------------------------------------------
     2. Hero parallax
     Moves the background image up as you scroll — creates depth.
     ---------------------------------------------------------- */
  function initParallax() {
    var hero = document.querySelector('.hwc-landing-hero');
    var media = document.querySelector('.hwc-landing-hero__media');
    if (!hero || !media) return;

    var ticking = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      var heroH = hero.offsetHeight;

      if (scrollY <= heroH) {
        var shift = scrollY * 0.22;
        media.style.transform = 'scale(1.06) translateY(' + shift + 'px)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     3. Product card staggered reveal
     Only product cards get scroll reveals — text sections are
     always fully visible (no hidden states) to ensure readability.
     ---------------------------------------------------------- */
  function initReveal() {
    if (!window.IntersectionObserver) return;

    // Only enable card reveals — no opacity hiding on text sections
    document.documentElement.classList.add('hwc-scroll-ready');

    var cardSelectors = [
      '.hwc-landing-best-sellers__grid > *',
    ];

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hwc-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -20px 0px',
    });

    cardSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  /* ----------------------------------------------------------
     Boot
     ---------------------------------------------------------- */
  function boot() {
    initHeroEntrance();
    initParallax();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
